import {
  DriverVehicleTabs,
  useDriverVehicleTab,
} from '../components/driver-vehicle-tabs'
import { ActivitiesStatus } from './ActivitiesStatus'
import { VehicleActivitiesStatus } from './VehicleActivitiesStatus'

export const DrivingDataStatus: React.FC = () => {
  const [tab, setTab] = useDriverVehicleTab()
  const tabs = <DriverVehicleTabs tab={tab} onChange={setTab} />

  return tab === 'vehicle' ? (
    <VehicleActivitiesStatus tabs={tabs} />
  ) : (
    <ActivitiesStatus tabs={tabs} />
  )
}
